export type Service = {
  number: string
  title: { en: string; fa: string }
  description: { en: string; fa: string }
  proof: { en: string; fa: string }
}

export const services: Service[] = [
  {
    number: '01',
    title: { en: 'Influencer Marketing', fa: 'اینفلوئنسر مارکتینگ' },
    description: {
      en: 'Curated influencers, from micro to mega, selected based on cultural fit, audience quality, and verified performance.',
      fa: 'اینفلوئنسرهای منتخب، از میکرو تا مگا؛ انتخاب‌شده بر اساس تناسب فرهنگی، کیفیت مخاطب و عملکرد واقعی.',
    },
    proof: { en: '+100,000 Curated Influencers', fa: '+۱۰٬۰۰۰ اینفلوئنسر منتخب' },
  },
  {
    number: '02',
    title: { en: 'Campaign Design & Execution', fa: 'طراحی و اجرای کمپین' },
    description: {
      en: 'Coordinated execution: right message, right media, right audience.',
      fa: 'از ایده تا اجرای هماهنگ؛ پیام درست، در رسانه درست، برای مخاطب درست.',
    },
    proof: { en: '+700 Campaigns Executed', fa: '+۷۰۰ کمپین اجراشده' },
  },
  {
    number: '03',
    title: { en: 'Data-Driven Decisions', fa: 'داده‌هایی برای تصمیم‌های دقیق‌تر' },
    description: {
      en: 'MMM modeling to turn campaign performance into actionable, comparable data. • Analyzing campaign performance using MMM data to measure true impact on sales. • Moving beyond vanity metrics to measure the real impact of campaigns on your business.',
      fa: 'مدل‌سازی MMM برای تبدیل عملکرد کمپین به داده‌هایی که قابل تحلیل، مقایسه و تصمیم‌گیری هستند. • تحلیل عملکرد کمپین با مدل‌سازی MMM؛ از داده‌های رسانه‌ای تا تأثیر واقعی بر فروش. • داده‌هایی فراتر از ایمپرشن و ویو؛ برای اندازه‌گیری واقعی اثر کمپین بر کسب‌وکار.',
    },
    proof: { en: 'MMM & ROI', fa: 'MMM و ROI' },
  },
  {
    number: '04',
    title: { en: 'Analysis & Reporting', fa: 'تحلیل و گزارش' },
    description: {
      en: 'Precise tracking and transparent, audit-ready processes from launch to final report.',
      fa: 'ردیابی دقیق، گزارش‌های شفاف و فرآیندهایی قابل بررسی؛ از شروع کمپین تا گزارش نهایی.',
    },
    proof: { en: 'Transparent & Measurable Reporting', fa: 'گزارش‌دهی شفاف و قابل‌اندازه‌گیری' },
  },
  {
    number: '05',
    title: { en: 'Advertising on High-Traffic Pages', fa: 'تبلیغات در پیج‌های پربازدید' },
    description: {
      en: 'Reach real audiences through high-traffic, influential pages. • Campaign execution on selected, high-engagement pages with targeted reach and transparent reporting.',
      fa: 'دسترسی به مخاطبان واقعی، از طریق شبکه‌ای از پیج‌های پربازدید و اثرگذار. • اجرای کمپین در پیج‌های منتخب و پرمخاطب؛ با انتشار هدفمند و گزارش‌دهی شفاف.',
    },
    proof: { en: 'Media & Brand Alignment', fa: 'تناسب رسانه و برند' },
  },
  {
    number: '06',
    title: { en: 'Video Advertising on VOD Platforms', fa: 'تبلیغات در پلتفرم‌های VOD' },
    description: {
      en: 'Video advertising on top VOD platforms with broad reach, targeted distribution, and transparent reporting.',
      fa: 'تبلیغات ویدیویی در پلتفرم‌های پربیننده VOD؛ با دسترسی گسترده، انتشار هدفمند و گزارش‌دهی شفاف.',
    },
    proof: { en: 'Premium Video Advertising', fa: 'تبلیغات ویدیویی پریمیوم' },
  },
]
